export default __webpack_public_path__ + "static/media/landing_mobile_bg.f4e1fa8a.png";